import { BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiUrl, basePath } from './envUrl';
import { signOut } from '../utils/auth';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}${basePath}`,
  prepareHeaders: (headers) => {
    try {
      const token = localStorage.getItem('mobileShopToken');
      if (token) headers.set('Authorization', `Bearer ${token}`);
    } catch {
      /* ignore a browser that blocks storage */
    }
    return headers;
  },
});

/**
 * A 401 means the token has run out - after a shop day, or after a restart. Send
 * them back to the login screen rather than leaving dead buttons on the counter.
 * A 403 is different: they are logged in, just not allowed, and the screen says so.
 */
const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, options) => {
  const result = await rawBaseQuery(args, api, options);
  if (result.error && result.error.status === 401) {
    signOut();
  }
  return result;
};

/**
 * The single API slice. Every screen's endpoints are added with
 * `mobileShopApi.injectEndpoints({...})` in its own file under src/api.
 *
 * Tags drive refetching: a screen that lists brands provides 'Brand', and any
 * create / update / delete invalidates it so the list refreshes itself.
 */
export const mobileShopApi = createApi({
  reducerPath: 'mobileShopApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    'Brand',
    'Model',
    'Product',
    'Batch',
    'EmiBank',
    'Supplier',
    'Customer',
    'Purchase',
    'Imei',
    'Bill',
    'ShopSetting',
    'User',
    'Permission',
  ],
  endpoints: () => ({}),
});
